import { Box, Button, Container, Grid2, Typography } from "@mui/material";
import { DataGrid, type GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Outlet, Link } from "react-router-dom";

import {
  ProductUpdate,
  ProductUpdatePcm,
} from "api/memberPortal/product/productUpdate/productUpdate.types";

import ProductUpdatePreview from "./components/ProductUpdatePreview";

interface ProductUpdatesBaseProps<T extends ProductUpdate | ProductUpdatePcm> {
  productUpdates: T[];
  isLoading: boolean;
  columns: GridColDef<T>[];
}

const ProductUpdatesBase = <T extends ProductUpdate | ProductUpdatePcm>({
  columns,
  productUpdates = [],
  isLoading,
}: ProductUpdatesBaseProps<T>) => {
  const [selectedUpdate, setSelectedUpdate] = useState<T>();

  useEffect(() => {
    if (productUpdates.length === 0) setSelectedUpdate(undefined);

    setSelectedUpdate(productUpdates[0]);
  }, [productUpdates]);

  return (
    <Container maxWidth="xl">
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        my={2}
      >
        <Typography variant="h1">Manage Post Listing Updates</Typography>
        <Button component={Link} variant="contained" color="success" to="add">
          Issue New Update
        </Button>
      </Box>

      <Grid2 container gap={3}>
        <Grid2 size={6} flex={1}>
          <DataGrid
            columns={columns}
            rows={productUpdates}
            disableColumnFilter
            disableColumnMenu
            hideFooterSelectedRowCount
            hideFooter
            onRowClick={({ row }) => setSelectedUpdate(row)}
            rowSelectionModel={[
              selectedUpdate?.id ?? productUpdates[0]?.id ?? 0,
            ]}
            loading={isLoading}
            localeText={{
              noRowsLabel: "No updates currently issued",
            }}
            sx={{
              height: "min-content",
              "& .MuiDataGrid-row": {
                cursor: "pointer",
              },
              "& .MuiDataGrid-cell:focus": {
                outline: "none",
              },
            }}
          />
        </Grid2>

        <Grid2 size={5}>
          <ProductUpdatePreview selectedUpdate={selectedUpdate} />
        </Grid2>
      </Grid2>

      <Outlet />
    </Container>
  );
};
export default ProductUpdatesBase;
